export class ProviderNoteRetentionModel {
  providerNoteRetentionId: number = 0;
  providerNoteId: number = 0;
  taxId: number = 0;
  baseValue: number = 0;
  taxRate: number = 0;
  swManual: boolean = false;
  createDate: Date | null = null;
  userNameCreate: string | null = null;
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
}
